<template>
  <div
    :class="[
      'w-screen py-3 px-3',
      type === 'success'
        ? 'bg-brand-green'
        : type === 'info'
        ? 'bg-brand-blue'
        : 'bg-brand-red'
    ]"
  >
    <div class="flex flex-row">
      <div class="flex mx-auto">
        <div class="flex items-center">
          <template v-if="icon === 'check'">
            <CheckIcon class="text-white w-5 h-5 mr-2" />
          </template>
          <template v-if="icon === 'star'">
            <StarIcon class="text-white w-5 h-5 mr-2" />
          </template>
          <template v-if="icon === 'x'">
            <XIcon class="text-white w-5 h-5 mr-2" />
          </template>
        </div>
        <div class="flex items-center">
          <p class="text-white font-light">{{ content }}</p>
        </div>
      </div>
      <XIcon
        class="w-5 h-5 text-white cursor-pointer"
        v-if="hasClose"
        @click="$emit('close-toast')"
      />
    </div>
  </div>
</template>
<script>
import { CheckIcon, StarIcon, XIcon } from "@heroicons/vue/outline"
export default {
  components: {
    CheckIcon,
    StarIcon,
    XIcon
  },
  props: {
    type: {
      type: String,
      default: "info" //danger, success, info
    },
    hasClose: {
      type: Boolean,
      default: false
    },
    content: {
      type: String
    },
    icon: {
      type: String
    }
  }
}
</script>
